/** Grymwyrd traduction française pour la mise en page partagée (TopNav + Footer). */
export const layoutFr = {
  'layout.nav.veil': 'Le Voile',
  'layout.nav.encyclopedia': 'Encyclopédie',
  'layout.nav.world': 'Le Monde',
  'layout.nav.play': 'Jouer',
  'layout.nav.books': 'Livres & Règles',
  'layout.nav.community': 'Communauté',
  'layout.nav.homeAria': 'Accueil de {world}',
  'layout.nav.search': 'Parcourir l\'encyclopédie',
  'layout.nav.unmute': 'Activer l\'ambiance sonore',
  'layout.nav.mute': 'Désactiver l\'ambiance sonore',
  'layout.nav.coinBalance': 'Solde de monnaie',
  'layout.nav.signedInAs': 'Connecté en tant que {name}',
  'layout.nav.enter': 'Entrer dans {world}',
  'layout.nav.toggleMenu': 'Basculer le menu',
  'layout.nav.dashboard': 'Mon {world} ({name})',
  'layout.nav.signOut': 'Déconnexion',

  'layout.footer.hideLinks': 'Masquer les liens du site',
  'layout.footer.showLinks': 'Liens du site & mentions légales',
  'layout.footer.tagline': 'Le monde vivant d\'horreur-fantasy où votre légende devient canon.',
  'layout.footer.explore': 'Explorer',
  'layout.footer.legal': 'Mentions légales',
  'layout.footer.accessibility': 'Accessibilité',
  'layout.footer.encyclopedia': 'Encyclopédie',
  'layout.footer.world': 'Le Monde',
  'layout.footer.playVtt': 'Jouer (VTT)',
  'layout.footer.books': 'Livres & Règles',
  'layout.footer.terms': 'Conditions de service',
  'layout.footer.privacy': 'Politique de confidentialité',
  'layout.footer.canonRelease': 'Autorisation de soumission canon',
  'layout.footer.aiPolicy': 'Politique IA',
  'layout.footer.cookies': 'Préférences de cookie',
  'layout.footer.copyright': '© 2026 GameCodex',
}
